export const HEADER_ID = "case-studies-carousel-header";
